
import { computed, defineComponent } from "vue";

import {
  ColumnDefinition,
  useDataTable,
  CountButton,
  BaseButton,
  EditIcon,
  DeleteIcon,
  DataTable,
} from "@tager/admin-ui";
import { useResourceDelete } from "@tager/admin-services";
import { Page } from "@tager/admin-layout";

import { deleteBrand, getBrandList } from "@/services/requests";
import { BrandType } from "@/typings/model";
import {
  getFieldListUrl,
  getProductListUrl,
  getBrandFormUrl,
} from "@/utils/paths";
import { getWebsiteOrigin } from "@/utils/common";

const COLUMN_DEFS: Array<ColumnDefinition<BrandType>> = [
  {
    id: 1,
    name: "ID",
    field: "id",
    style: { width: "50px", textAlign: "center" },
    headStyle: { width: "50px", textAlign: "center" },
  },
  {
    id: 3,
    name: "Картинка",
    field: "image",
    type: "image",
    style: { width: "100px" },
    headStyle: { width: "100px" },
  },
  {
    id: 2,
    name: "Название",
    field: "name",
    type: "name",

    format: ({ row }) => ({
      adminLink: {
        text: row.name,
        url: getBrandFormUrl({ brandId: row.id }),
      },
      websiteLink: {
        text: getWebsiteOrigin() + row.url,
        url: getWebsiteOrigin() + row.url,
      },
    }),
  },
  {
    id: 4,
    name: "",
    field: "products",
    style: { width: "101px", whiteSpace: "nowrap" },
    headStyle: { width: "101px" },
  },
  {
    id: 5,
    name: "Действия",
    field: "actions",
    style: { width: "101px", textAlign: "center", whiteSpace: "nowrap" },
    headStyle: { width: "101px", textAlign: "center" },
  },
];

export default defineComponent({
  name: "BrandList",
  components: {
    CountButton,
    BaseButton,
    EditIcon,
    DeleteIcon,
    DataTable,
    Page,
  },
  setup() {
    const {
      isLoading: isBrandListLoading,
      rowData: brandList,
      errorMessage,
      searchQuery,
      handleChange,
      fetchEntityList: fetchBrandList,
    } = useDataTable<BrandType>({
      fetchEntityList: (params) => getBrandList({ query: params.searchQuery }),
      initialValue: [],
      resourceName: "Brand list",
    });

    const { handleResourceDelete: handleBrandDelete, isDeleting } =
      useResourceDelete({
        deleteResource: deleteBrand,
        resourceName: "Brand",
        onSuccess: fetchBrandList,
      });

    const isRowDataLoading = computed<boolean>(() => isBrandListLoading.value);

    function isBusy(brandId: number): boolean {
      return isDeleting(brandId) || isRowDataLoading.value;
    }

    return {
      columnDefs: COLUMN_DEFS,
      rowData: brandList,
      isRowDataLoading,
      errorMessage,
      isBusy,
      handleBrandDelete,
      getBrandFormUrl,
      getFieldListUrl,
      getProductListUrl,
      searchQuery,
      handleChange,
    };
  },
});
